export interface WidgetDuration {
  hours?: number
  minutes?: number
  seconds?: number
}

// Average-duration KPI intentionally renders seconds-based values as total minutes + seconds.
export const toWidgetDurationFromSeconds = (totalSeconds: number): WidgetDuration => {
  const total = Math.max(0, Math.round(totalSeconds))
  const minutes = Math.floor(total / 60)
  const seconds = total % 60

  return { minutes, seconds }
}

export const toWidgetDurationFromMinutes = (totalMinutes: number): WidgetDuration => {
  const total = Math.max(0, Math.round(totalMinutes))

  return {
    hours: Math.floor(total / 60),
    minutes: total % 60,
  }
}
